/**
 * Warm Analog Sound Wave & Acoustic Resonance Canvas Visualizer
 * Adapts dynamically for crisp display on bright white backgrounds
 */
export function initAudioVisualizer() {
  const canvas = document.getElementById('heroCanvas');
  if (!canvas) return;

  const ctx = canvas.getContext('2d');
  let animationFrameId;

  function resizeCanvas() {
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  }
  
  resizeCanvas();
  window.addEventListener('resize', resizeCanvas);

  // Acoustic particles (warm ambient dust motes in studio spotlight)
  const pointsCount = 35;
  const points = [];
  
  for (let i = 0; i < pointsCount; i++) {
    points.push({
      x: Math.random() * canvas.width,
      y: Math.random() * canvas.height,
      radius: Math.random() * 2 + 1,
      vx: (Math.random() - 0.5) * 0.6,
      vy: (Math.random() - 0.5) * 0.6,
      alpha: Math.random() * 0.4 + 0.15
    });
  }

  let phase = 0;

  function draw() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const isDark = document.documentElement.getAttribute('data-theme') === 'dark';
    const centerY = canvas.height * 0.5;
    phase += 0.015;

    // Draw warm organic acoustic sine waves
    for (let waveIndex = 0; waveIndex < 3; waveIndex++) {
      ctx.beginPath();
      ctx.lineWidth = waveIndex === 0 ? 2 : 1.2;
      
      const strokeGrad = ctx.createLinearGradient(0, 0, canvas.width, 0);
      if (isDark) {
        strokeGrad.addColorStop(0, 'rgba(229, 169, 80, 0.03)');
        strokeGrad.addColorStop(0.5, waveIndex === 0 ? 'rgba(229, 169, 80, 0.35)' : 'rgba(200, 100, 50, 0.2)');
        strokeGrad.addColorStop(1, 'rgba(140, 83, 43, 0.03)');
      } else {
        strokeGrad.addColorStop(0, 'rgba(217, 119, 6, 0.05)');
        strokeGrad.addColorStop(0.5, waveIndex === 0 ? 'rgba(217, 119, 6, 0.45)' : 'rgba(194, 65, 12, 0.25)');
        strokeGrad.addColorStop(1, 'rgba(120, 53, 15, 0.05)');
      }

      ctx.strokeStyle = strokeGrad;

      for (let x = 0; x < canvas.width; x += 10) {
        const freqMultiplier = (waveIndex + 1) * 0.0025;
        const amplitude = 35 + waveIndex * 20;
        const y = centerY + Math.sin(x * freqMultiplier + phase + waveIndex) * amplitude * Math.cos(x * 0.0008);

        if (x === 0) {
          ctx.moveTo(x, y);
        } else {
          ctx.lineTo(x, y);
        }
      }
      ctx.stroke();
    }

    // Draw warm dust motes
    for (let i = 0; i < points.length; i++) {
      const p = points[i];

      p.x += p.vx;
      p.y += p.vy;

      if (p.x < 0 || p.x > canvas.width) p.vx *= -1;
      if (p.y < 0 || p.y > canvas.height) p.vy *= -1;

      ctx.beginPath();
      ctx.arc(p.x, p.y, p.radius, 0, Math.PI * 2);
      ctx.fillStyle = isDark ? `rgba(229, 169, 80, ${p.alpha})` : `rgba(217, 119, 6, ${p.alpha})`;
      ctx.shadowBlur = isDark ? 8 : 4;
      ctx.shadowColor = '#d97706';
      ctx.fill();
      ctx.shadowBlur = 0;
    }

    animationFrameId = requestAnimationFrame(draw);
  }

  draw();

  // Dynamic Frequency bar fluctuations in interactive card
  const freqBars = document.querySelectorAll('.freq-bar');
  if (freqBars.length > 0) {
    setInterval(() => {
      freqBars.forEach(bar => {
        const randomHeight = Math.floor(Math.random() * 65 + 25);
        bar.style.height = `${randomHeight}%`;
      });
    }, 450);
  }

  return () => {
    cancelAnimationFrame(animationFrameId);
    window.removeEventListener('resize', resizeCanvas);
  };
}
